import { render, staticRenderFns } from "./PostulantEnglishPromotion.vue?vue&type=template&id=ccbe30c8&"
import script from "./PostulantEnglishPromotion.vue?vue&type=script&lang=js&"
export * from "./PostulantEnglishPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports